.listItemIcon {
  color: inherit;
}

/* Keep the compact sidebar density the rows had as menu items: no row margins, 20px icons, one line.
   Scoped by the row marker so the Mixer/Tuner/Keyboard rows, built in other packages, match. */
.tools [data-list-row] {
  margin: 0;
  padding: 6px 16px;
  gap: 8px;
  white-space: nowrap;
}

.tools [data-list-row] svg {
  width: 20px;
  height: 20px;
}
